import { apiPost } from '../../lib/api'

// Mirrors the Auth slices on the API. The refresh token never appears here: it lives
// in an httpOnly cookie the browser attaches to /api/auth/* on its own.

export interface AuthUser {
  id: string
  email: string
  roles: string[]
  tenantId: string
}

export interface AuthSession {
  accessToken: string
  expiresAt: string
  user: AuthUser
}

/**
 * ProblemDetails title the API answers when a concurrent refresh (another tab) just
 * rotated the cookie. Contract with AuthEndpoints.cs; the E2E multi-tab spec breaks
 * if either side drifts.
 */
export const sessionSupersededTitle = 'Session renewed elsewhere'

export function login(email: string, password: string): Promise<AuthSession> {
  return apiPost<AuthSession>('/api/auth/login', { email, password })
}

let refreshInFlight: Promise<AuthSession> | null = null

/**
 * One network call no matter how many callers ask at once. Refresh tokens rotate on
 * use, so two concurrent refreshes would race: the second would present an
 * already-rotated token and the API would revoke the whole session as a replay.
 * (StrictMode's double mount alone would trigger exactly that.)
 */
export function refreshSession(): Promise<AuthSession> {
  refreshInFlight ??= apiPost<AuthSession>('/api/auth/refresh', {}).finally(() => {
    refreshInFlight = null
  })
  return refreshInFlight
}

export function logout(): Promise<void> {
  return apiPost<void>('/api/auth/logout', {})
}
